// extracted by mini-css-extract-plugin
export default {"withImage":"SubHeader_withImage__4vx1+","lessons_list_wrapper":"SubHeader_lessons_list_wrapper__KGNFQ","lessons_list":"SubHeader_lessons_list__ITgwh"};